import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";
import { checkIsCategoryList, checkIsExplicitBlankVote, checkIsInvalidVote, checkIsWriteIn, getCandidateSlate, getSlateName, hasSlateMembers, } from "@sequentech/ui-core";
var BallotSlatesContext = createContext(null);
/**
 * The slates of the ballot below, as the screen read them from the ballot style.
 *
 * Without a provider the ballot shows no slate labels.
 */
export var BallotSlatesProvider = function (_a) {
    var slates = _a.slates, children = _a.children;
    return (_jsx(BallotSlatesContext.Provider, { value: slates, children: children }));
};
export var useBallotSlates = function () { return useContext(BallotSlatesContext); };
export var getDefaultLanguageCode = function (ballotStyle) {
    var _a, _b, _c, _d, _e;
    return (_c = (_b = (_a = ballotStyle.ballot_eml.election_presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) !== null && _c !== void 0 ? _c : (_e = (_d = ballotStyle.ballot_eml.election_event_presentation) === null || _d === void 0 ? void 0 : _d.language_conf) === null || _e === void 0 ? void 0 : _e.default_language_code;
};
var isBallotMarker = function (candidate) {
    return checkIsWriteIn(candidate) ||
        checkIsInvalidVote(candidate) ||
        checkIsExplicitBlankVote(candidate) ||
        checkIsCategoryList(candidate);
};
/**
 * What a candidate is shown as belonging to: the name of their slate, or the
 * independent label in a contest where other candidates are on a slate.
 */
export var useCandidateSlateLabel = function (ballotStyle, contest, candidate) {
    var slates = useBallotSlates();
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    if (!slates || !hasSlateMembers(slates, contest.id) || isBallotMarker(candidate)) {
        return undefined;
    }
    var slate = getCandidateSlate(slates, contest.id, candidate.id);
    return slate
        ? getSlateName(slate, i18n.language, getDefaultLanguageCode(ballotStyle))
        : t("slates.independent");
};
